export default __webpack_public_path__ + "static/media/our-story-img11.ca546d22.jpg";